import React from 'react';

import type { DashboardOverview, DashboardPeriod } from '../types';
import { kpiComparisonCaption } from '../utils/kpiComparisonLabel';
import { DashboardKpiCard } from './DashboardKpiCard';

type DashboardKpiCardsProps = {
  period: DashboardPeriod;
  kpis: DashboardOverview['kpis'];
  kpiComparison: DashboardOverview['kpiComparison'];
  syncing?: boolean;
  visible: {
    umsatz: boolean;
    anfragen: boolean;
    emails: boolean;
  };
};

const UMSATZ_LABEL: Record<DashboardPeriod, string> = {
  today: 'Umsatz heute',
  week: 'Umsatz',
  month: 'Umsatz',
};

const ANFRAGEN_LABEL: Record<DashboardPeriod, string> = {
  today: 'Anfragen heute',
  week: 'Neue Anfragen',
  month: 'Neue Anfragen',
};

const EMAILS_LABEL: Record<DashboardPeriod, string> = {
  today: 'E-Mails heute',
  week: 'E-Mails',
  month: 'E-Mails',
};

export function DashboardKpiCards({ period, kpis, kpiComparison, syncing, visible }: DashboardKpiCardsProps) {
  const comparisonLabel = kpiComparisonCaption(kpiComparison);
  const cards: Array<{ label: string; kpi: DashboardOverview['kpis'][keyof DashboardOverview['kpis']] }> = [];

  if (visible.umsatz) cards.push({ label: UMSATZ_LABEL[period], kpi: kpis.umsatz });
  if (visible.anfragen) cards.push({ label: ANFRAGEN_LABEL[period], kpi: kpis.anfragen });
  if (visible.emails) cards.push({ label: EMAILS_LABEL[period], kpi: kpis.emails });

  if (!cards.length) return null;

  const smCols = cards.length === 1 ? 'sm:grid-cols-1' : cards.length === 2 ? 'sm:grid-cols-2' : 'sm:grid-cols-3';

  return (
    <div className={`grid grid-cols-1 gap-4 ${smCols} transition-opacity ${syncing ? 'opacity-50' : 'opacity-100'}`}>
      {cards.map((c) => (
        <DashboardKpiCard key={c.label} label={c.label} kpi={c.kpi} comparisonLabel={comparisonLabel} />
      ))}
    </div>
  );
}
